import React, { FC } from "react";
import { useAppStore } from "@/store/useAppStore";

interface Props {
  children: React.ReactNode;
}
export const ModalWrapper: FC<Props> = ({ children }) => {
  const { isModalOpen, setIsModalOpen, setActiveModal } = useAppStore();
  if (!isModalOpen) {
    return null;
  }
  const onClose = () => {
    setIsModalOpen(false);
    setActiveModal(null);
  }
  return (
    isModalOpen && <div
      className="fixed inset-0 bg-black/80 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div onClick={(e) => e.stopPropagation()}>{children}</div>
    </div>
  );
};
